import DatePicker, {ReactDatePickerProps, registerLocale, setDefaultLocale} from "react-datepicker";
import {css, Theme} from "@emotion/react";
import {pl} from "date-fns/locale";

import {backgroundColor, borderRadius, calculateRemSize, color, flexAbsoluteCenter, p, textAlign, w100} from "@pg-design/helpers-css";

const clearIcon = require("../assets/clear_icon.svg");

import "react-datepicker/dist/react-datepicker.css";

export type DatepickerProps = ReactDatePickerProps & {
    //all props: https://github.com/Hacker0x01/react-datepicker/blob/main/docs/datepicker.md
    className?: string;
    error?: boolean;
};

registerLocale("pl", pl);
setDefaultLocale("pl");

export const Datepicker = ({
    className,
    dateFormat = "dd/MM/yyyy",
    placeholderText = "Proszę wybrać datę...",
    isClearable = true,
    error,
    ...datepickerProps
}: DatepickerProps) => {
    return (
        <div css={wrapper}>
            <DatePicker
                placeholderText={placeholderText}
                css={[datepicker, error ? errorState : null]}
                dateFormat={dateFormat}
                isClearable={isClearable}
                clearButtonClassName="clearBtn"
                calendarClassName="datepicker-calendar"
                wrapperClassName={className}
                calendarStartDay={1}
                {...datepickerProps}
            />
        </div>
    );
};

const wrapper = css`
    ${w100};

    .datepicker-calendar {
        transform: scale(1.5) translate(35px, 35px);
    }
`;

const datepicker = (theme: Theme) => css`
    ${p(1.5, 1.5, 1.5, 2)}
    ${color(theme.colors.secondary)};
    ${backgroundColor("transparent")};
    border: 1px solid ${theme.colors.gray["600"]};
    ${w100};
    ${borderRadius(1)};

    &::placeholder {
        ${color(theme.colors.gray["700"])};
    }

    &:disabled {
        background-color: ${theme.colors.gray[100]};
    }

    outline: 0;

    &:focus {
        outline: 0;
    }

    + .clearBtn {
        :after {
            ${flexAbsoluteCenter};
            height: ${calculateRemSize(2)};
            width: ${calculateRemSize(2)};
            ${textAlign("center")};
            ${color(theme.colors.secondary)};
            ${backgroundColor("transparent")}
            content: url("${clearIcon}");
        }
    }
`;

const errorState = (theme: Theme) => css`
    border-color: ${theme.colors.danger};
`;
